module.exports = __webpack_public_path__ + "img/2023.a6c006ef.png";